import _ from 'lodash';

export const exrTypeList = [
    {id: 1, label: '4选1选词填空', require: ['xctk_4x1', 'xctk_4x1_items']},
    {id: 2, label: '4选1看图片、选词填空', require: ['xctk_4x1', 'xctk_4x1_items']},
    {id: 3, label: '4选1听录音、选词填空', require: ['xctk_4x1', 'xctk_4x1_items']},
    {id: 13, label: '4选1看翻译、选词填空', require: ['xctk_4x1', 'xctk_4x1_items']},
    {id: 4, label: '4选2选词填空', require: ['xctk_4x2', 'xctk_4x2_items']},
    {id: 5, label: '4选2看图片、选词填空', require: ['xctk_4x2', 'xctk_4x2_items']},
    {id: 6, label: '4选2听录音、选词填空', require: ['xctk_4x2', 'xctk_4x2_items']},
    {id: 14, label: '4选2看翻译、选词填空', require: ['xctk_4x2', 'xctk_4x2_items']},
    {id: 7, label: '排词成句', require: ['pxt']},
    {id: 8, label: '看翻译，排词成句', require: ['pxt']},
    {id: 9, label: '听录音，排词成句', require: ['pxt']},
    {id: 10, label: '选择正确的位置', require: ['xktc']},
    {id: 11, label: '跟读题'},
    {id: 12, label: '复述题'},
];

export function getDataJson(val) {
    if (_.isEmpty(val)) {
        return '';
    }
    const keys = Object.keys(val).filter(k => !_.isEmpty(val[k]));
    if (!keys.length) {
        return '';
    }
    return JSON.stringify(keys.reduce((obj, ck) => {
        obj[ck] = val[ck];
        return obj;
    }, {}));
}

export function normalText(text) {
    if (text === null || text === undefined) {
        text = '';
    }
    return text.replace(/[.。]{3,}/g, '......') //将多个连字符替换标准的......
        //标点符号前后都要增加空格
        .replace(/ *([,.?;!、，。？！]+) */g, ' $1 ')
        //下划线前面增加空格，后面不要
        .replace(/ *_[ _]*/g, ' __')
        //如果下划线在最后面，则不能有空格，否则拼音对不上
        .replace(/ +__$/, '__')
        //竖线前后不要空格
        .replace(/ *[|｜\\/\\]+ */g, '|')
        //尖括号为正确答案位置，前后需要空格
        .replace(/ *[【\\[](.*?)[】\]] */g, (str, mm) => {
            return ' [' + mm.replace(/ +/g, ' ').replace(/^\s+|\s+$/g, '') + '] ';
        })
        //替换多个空格为一个空格
        .replace(/ +/g, ' ')
        //去掉首尾空格
        .replace(/^\s+|\s+$/g, '');
}

export function normalWords(text, stdWords) {
    if (typeof stdWords === 'string') {
        stdWords = stdWords.split(' ');
    }
    if (text === null || text === undefined) {
        text = '';
    } else {
        text = normalText(text);
    }
    if (_.isArray(stdWords)) {
        const regWords = new RegExp('(' + stdWords.join('|') + ')', 'g');
        text = text.split('|').map(parts => {
            return parts.split(' ').map(wd => {
                if (stdWords.includes(wd.replace(/[_\\[\]]+/g, ''))) {
                    return wd;
                } else {
                    return wd.replace(regWords, '$1 ').replace(/ +$/, '');
                }
            }).join(' ');
        }).join('|');
    }
    return text;
}

export function normalPinyin(text) {
    const parts = [
        ['，', ','],
        ['。', '.'],
        ['？', '?'],
        ['！', '!'],
    ];
    text = normalText(text);
    parts.forEach(part => {
        text = text.replace(part[0], part[1]);
    });
    return text;
}

export function normalItems(text) {
    return text.replace(/\s*[,;|，；｜、\\/]+\s*/g, ',').replace(/^[\s,]+|[\s,]+$/g, '');
}

export function handleFormat(obj, format, path, opts = {}) {
    switch (format) {
        case 'text':
            format = normalText;
            break;
        case 'words':
            format = normalWords;
            break;
        case 'pinyin':
            format = normalPinyin;
            break;
        case 'items':
            format = normalItems;
            break;
    }
    if (_.isFunction(format)) {
        const text = formatText(format, _.get(obj, path), opts);
        _.set(obj, path, text);
    }
}

function formatText(format, text, opts) {
    if (typeof text === 'string') {
        if (opts.multiLine) {
            return text.split(/\r\n|\n/g).filter(s => s).map(format).join("\n");
        }
        return format(text);
    }
    if (_.isArray(text)) {
        return text.map(s => formatText(format, s, opts)).join("\n");
    }
    return "";
}

export function validateRule(stdWords) {
    if (typeof stdWords === 'string') {
        stdWords = stdWords.split(' ');
    }
    return (rule, value, callback) => {
        if (!value) {
            return callback();
        }
        const words = value.replace(/[_\\[\]【】]/g, '').split(/[ |]/g);
        if (words.length !== stdWords.length || _.difference(words, stdWords).length) {
            callback(new Error('分词间隔必须和原句一致'));
        }
    }
}

export function validateWords(stdWords, value, opts = {}) {
    if (typeof value === 'string' && opts.multiLine) {
        value = value.split(/\r\n|\n/g).filter(s => s);
    }
    if (_.isArray(value)) {
        for (const val of value) {
            const error = validateWords(stdWords, val);
            if (error) {
                return error;
            }
        }
        return;
    }
    if (typeof stdWords === 'string') {
        stdWords = stdWords.split(' ');
    }
    if (!value) {
        return;
    }
    const words = value.replace(/[_\\[\]【】]/g, '').split(/[ |]/g);
    if (words.length !== stdWords.length || _.difference(words, stdWords).length) {
        return '分词必须和原句一致';
    }
}